import { Component, OnInit, Inject } from '@angular/core';
import { _, StepComponent, SharedFacade, ICC_PAGE_DATA } from '@icc/configurator/shared';

@Component({
    selector: 'icc-system-info',
    templateUrl: './system-info.component.html',
    styleUrls: ['./system-info.component.scss'],
})
export class SystemInfoComponent extends StepComponent implements OnInit {
    public configurator = 'window';
    public stepId = 'systemInfo';
    public title = _('WINDOW|Informacja na temat produktu');
    public options = [];

    system: any = null;
    button = true;
    descriptionFieldName: string | null = null;
    imageFieldName: string | null = null;
    imageDirectory: string | null = null;

    constructor(
        private sharedFacade: SharedFacade,
        @Inject(ICC_PAGE_DATA) private pageData: {
            system: any,
            button: boolean,
            descriptionFieldName: string,
            imageFieldName: string,
            imageDirectory: string
        }
    ) {
        super();
    }

    ngOnInit() {
        this.system = this.pageData.system || {};
        this.button = this.pageData.button;
        this.descriptionFieldName = this.pageData.descriptionFieldName || 'content';
        this.imageFieldName = this.pageData.imageFieldName || 'title_image';
        this.imageDirectory = this.pageData.imageDirectory || 'windowline';
    }

    close() {
        this.sharedFacade.closePage(true);
    }
}
